/*
 * @Author: Teemo Ding
 * @Date: 2021-08-12 18:09:34
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-12-31 17:11:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/Components/RemovePopup/index.tsx
 */
import { Input, ModalFooter } from '@/src/components/Antd';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const RemovePopup = ({ onDelete, onCancel, type }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();

  return (
    <Fragment>
      <div className={css.container}>
        <p>
          {type == 'Subscriber'
            ? getI18n('customerList.removePopup.remove_sub')
            : getI18n('customerList.removePopup.irreversible')}
        </p>
        <Form form={form} name='removePopup' onFinish={onDelete}>
          <Form.Item
            name='name'
            labelCol={{ span: 24 }}
            validateFirst={true}
            rules={[
              {
                required: true,
                message:
                  type == 'Subscriber'
                    ? getI18n('customerList.removePopup.rEMOVE')
                    : getI18n('customerList.removePopup.eRASE'),
              },
              {
                validator: (_, value) =>
                  (type == 'Subscriber' && value.toUpperCase() == 'REMOVE') ||
                  (type !== 'Subscriber' && value.toUpperCase() == 'ERASE')
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          type == 'Subscriber'
                            ? getI18n('customerList.removePopup.rEMOVE')
                            : getI18n('customerList.removePopup.eRASE'),
                        ),
                      ),
              },
            ]}
            label={
              type == 'Subscriber'
                ? getI18n('customerList.removePopup.rEMOVEConfirm')
                : getI18n('customerList.removePopup.eRASEConfirm')
            }>
            <Input size='large' maxLength={500} />
          </Form.Item>
        </Form>
      </div>
      <ModalFooter
        danger
        onOk={() => form.submit()}
        okText={
          type == 'Subscriber'
            ? getI18n('general.remove')
            : getI18n('customerList.removePopup.eRASE')
        }
        onCancel={onCancel}
      />
    </Fragment>
  );
};

export default RemovePopup;
